<template>
    <div class="email-list my-3">
        <label class="form-label email-list-label mb-2 d-block">Choisir les emails à associer</label>

        <div v-for="(email, idx) in emails" :key="idx" class="email-entry mb-3">
            <div class="email-row">
                <input
                    type="email"
                    class="form-control email-input"
                    v-model="emails[idx]"
                    :placeholder="placeholderForIndex(idx)"
                    @keydown.enter.prevent="addEmail" />
                <button v-if="emails.length > 1" class="btn email-remove-btn" type="button" @click="removeEmail(idx)">Supprimer</button>
            </div>
            <small class="email-hint">Entrée pour ajouter une ligne.</small>
        </div>

        <button class="btn btn-success btn-sm btn-circle" type="button" :disabled="emails.length >= maxEmails" @click="addEmail">
            + Ajouter un email
        </button>
        <p class="email-note">{{ $tl("labels.notifications.recipientsHint") }}</p>
    </div>
</template>
<script>
export default {
    props: {
        mainEmail: {
            type: String,
            default: null,
        },
        userNotificationsSetting: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            emails: [],
            maxEmails: 5,
        };
    },
    created() {
        const recipients = this.userNotificationsSetting.recipients;
        if (!Array.isArray(recipients) || recipients.length === 0) {
            this.emails = [this.mainEmail || ""];
            this.userNotificationsSetting.recipients = [];
        } else {
            this.emails = recipients;
        }
    },
    watch: {
        emails: {
            deep: true,
            handler(newVal, oldVal) {
                this.userNotificationsSetting.recipients = newVal;
            },
        },
    },
    methods: {
        addEmail() {
            if (this.emails.length >= this.maxEmails) {
                return;
            }
            this.emails.push("");
        },
        removeEmail(idx) {
            this.emails.splice(idx, 1);
        },
        placeholderForIndex(idx) {
            if (idx === 0) {
                return "ex: prenom.nom@domaine.com";
            }
            return `ex: prenom.nom+${idx}@domaine.com`;
        },
    },
};
</script>

<style scoped>
.email-list-label {
    color: #2d3a4a;
    font-weight: 700;
}

.email-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.email-input {
    border: 1px solid #e3eaf2;
    border-radius: 10px;
    box-shadow: none;
    height: 42px;
}

.email-input:focus {
    border-color: #9ad7df;
    box-shadow: 0 0 0 3px rgba(34, 168, 183, 0.12);
}

.email-remove-btn {
    border: 1px solid #f05a5a;
    color: #f05a5a;
    background: #fff;
    border-radius: 999px;
    padding: 8px 18px;
    font-weight: 600;
    white-space: nowrap;
}

.email-remove-btn:hover {
    background: #fff5f5;
    color: #e24c4c;
}

.email-hint {
    display: block;
    color: #90a0b2;
    font-size: 12px;
    margin-top: 6px;
}

.email-note {
    color: #90a0b2;
    font-size: 12px;
    margin-top: 8px;
    margin-bottom: 0;
}
</style>
